import { mutatorAction } from "satcheljs";
import getStore from "../store/store";

const setClassicIndentedViewMutator: (isClassicIndentedView: boolean) => void = mutatorAction("setClassicIndentedView", (isClassicIndentedView: boolean): void => {
    getStore().isClassicIndentedView = isClassicIndentedView;
});
export default setClassicIndentedViewMutator;
